import { isStandardBrowserEnv } from '@dimjs/lang';
import { utils } from '../../utils/index.js';
import { fabric } from './api.js';
import { bootstrap } from './bootstrap.js';

// Auto boostrap bridge engine.
(function () {
  if (isStandardBrowserEnv()) {
    const { webview, log } = utils;
    if (webview.isFabricWebview() && webview.isIphone()) {
      // Load bridge core in `ios` webview.
      log.logData('Load bridge core in `ios` webview...');
      // Bootstrap brige infrastructure
      bootstrap(fabric);
    }
  }
})();

export const fabricIos = fabric;
